import Loader from "@img/Loader.svg";

const WithFlexContainer = ({ src }: { src?: string }) => {
  if (!src) {
    return <img className="loader-img" src={Loader} />;
  }

  return (
    <iframe
      src={src}
      title="WithFlex HSA/FSA Checkout"
      allow="payment 'src'; publickey-credentials-get 'src'"
      // Security Note: No sandbox attribute used because WithFlex requires JavaScript + same-origin
      // access to its own cookies. The combination of allow-scripts + allow-same-origin would
      // create a sandbox escape vulnerability. Instead, we rely on:
      // 1. Permissions Policy (allow attribute) to limit capabilities to payment APIs only
      // 2. Referrer Policy to prevent information leakage
      // 3. Trust in WithFlex as a payment provider
      referrerPolicy="strict-origin-when-cross-origin"
      style={{ width: "100%", height: "100%", border: "none" }}
    />
  );
};

export default WithFlexContainer;
